import { hasReadPermission, hasCreatePermission, hasUpdatePermission, hasDeletePermission, hasAdminRole, hasSuperAdminRole } from "@/auth/utils";

export default {
    methods: {
        hasReadPermission,
        hasCreatePermission,
        hasUpdatePermission,
        hasDeletePermission,
        hasAdminRole,
        hasSuperAdminRole,
    },
}